import React from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import ShieldLockOutlinedIcon from '@tenancy.nz/icons/ShieldLockOutlined';
import {Box, Text} from '@tenancy.nz/ui';
import MessageFeature from '../message/MessageFeature';
import BannerContentLayout from '../../layouts/BannerContentLayout';
import FooterFeature from '../footer/footer-feature';
import Title from '../../ui/title';
import useRouteTitle from '../../hooks/use-route-title';
import * as consts from '../../utils/constants/url';
import banner from '../../assets/banner-portrait.jpg';

const AUTH_ROUTES = [
  consts.SLUG_LOGIN,
  consts.SLUG_LOGIN_VERIFY,
  consts.SLUG_FORGOTTEN,
  consts.SLUG_RESET,
  consts.SLUG_VERIFY_FULL_RESET,
  consts.SLUG_REGISTER,
];

function LayoutFeature() {
  const {pathname} = useLocation();
  const message = useSelector(state => state.message);
  const title = useRouteTitle();

  const isLoginRoute = AUTH_ROUTES.includes(pathname);

  const content = (
    <>
      {title && <Title text={title} />}
      {message.show && (
        <Box mb={5}>
          <MessageFeature />
        </Box>
      )}
      <Outlet />
    </>
  );

  return (
    <BannerContentLayout
      disableBannerOnMobile
      content={
        isLoginRoute ? (
          <Box
            sx={{
              width: '100%',
              maxWidth: '450px',
              mx: 'auto',
            }}>
            {content}
            <Text
              variant="body2"
              color="#6E668F"
              weight="400"
              sx={{
                my: 6,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
              }}>
              <ShieldLockOutlinedIcon color="#6E668F" />
              Password protected, secure login.
            </Text>
          </Box>
        ) : (
          content
        )
      }
      footer={<FooterFeature />}
      imgSrc={banner}
    />
  );
}

export default LayoutFeature;
